// extracted by mini-css-extract-plugin
export default {"container":"VD-z","innerContainer":"WD-z","multipleLines":"XD-z","heading":"YD-z","content":"ZD-z","linkColor":"_D-z"};